import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
  useCallback,
} from "react";
import {
  Card,
  Col,
  Row,
  Switch,
  Button,
  Badge,
  Avatar,
  Spin,
  Checkbox,
  Input,
  Select,
  Modal,
  Form,
  DatePicker,
  Space,
} from "antd";
import {
  CloseOutlined,
  LeftOutlined,
  RadiusBottomleftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import Styled from "styled-components";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ComposedChart,
  Line,
} from "recharts";
import FilterIcon from "../../assets/images/Filter-Icon.svg";
import ExportIcon from "../../assets/images/Export-Icon.svg";
import { CALL_API } from "../../Common/api";
import UIModal from "../../Reusablecomponents/UIModal";
import {
  ButtonFilled,
  Buttontransparent,
  DashboardButton,
  DashboardNav,
} from "../../Reusablecomponents/UIButtons";
import { WidgetsAi, shipmentType } from "../../Common/constant";
import { useSelector } from "react-redux";
import moment from "moment";
import dayjs from "dayjs";
import { handleDownloadChart } from "../../Reusablecomponents/Export/Exportpdf";
import duration from "dayjs/plugin/duration";
import { ReactComponent as LeafMud } from "../../assets/images/mdi_leaf.svg";
import ContainerDashboard from "./ContainerDashboard";
import { pointer } from "@testing-library/user-event/dist/cjs/pointer/index.js";
import { color } from "highcharts";
import { useNavigate } from "react-router-dom";

dayjs.extend(duration);

const { Option } = Select;
const { RangePicker } = DatePicker;

const Styledashboard = Styled.div`
.ant-card .ant-card-head
{padding:10px!important}

@media (min-width: 319px) and (max-width: 375px) {
  #top-clients .recharts-surface{
    margin-top:-62% !important;
}
.compact_data{
   margin-top:-85% !important;

}
.container_scrollable{
  overflow-x: scroll !important;
}
}

@media (min-width: 375px) and (max-width: 426px) {
#top-clients .recharts-surface{
    margin-top:-50% !important;
}

.all-charts-scroll-container {
  width: 100%;
}

.container_scrollable {
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
}

.container_scrollable > div {
  width: 600px;
}


}


@media (min-width: 320px) and (max-width: 425px) {
  .addwidgets {
    background: red !important;
    color: white !important;
    border: 2px solid black !important;
  }
  .addwidgets_container{
  display:flex !important;
  flexDirection:row !important;
  gap:05px;
}
}
.range_picker{
  width: 100% !important;
}
.trends-value{
font-size: 12px;
text-align: end;
}
.overview-body{
/* padding: 16px; */
gap: 24px;
}
img {
  cursor: pointer !important;
}
.addwidget-btn{
  background-color: #E8FFEC;
  color:#2C963D;
  border:none;
}
.ant-card-head{
border-bottom: none;
}
.track-overview{
background:none;}
.rechart-legend-icon{
  width: 10px;
  height: 10px;
  border-radius: 50%;
  }
.stats-card{
   display: flex;
  flex-direction: column;

  height: 100%; 
  text-align: center;
  }
  .status_card1{
       display: flex;
    justify-content: space-between;;
    padding:3px;
  }

  .presentageValue{
  position:absolute;
  right:15px;
  font-size: 12px;
  
  }
  .ant-switch-checked {
  background-color: #31AB46 !important;
}
.Iconbg{
width:38px;
height:38px;
display:flex;
align-items:center;
justify-content:center;
border-radius:50%;
background-color: #EBF7ED;
}

.all-charts-scroll-container {
  display: flex;
  /* overflow-x: auto; */
  gap: 12px;
  padding-bottom: 20px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin; 
}

.all-charts-scroll-container::-webkit-scrollbar {
  height: 0px; /* Make scrollbar visible */
  background-color: #f1f1f1;
}

.all-charts-scroll-container::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 4px;
}
.chart-card {
  width: 100%; 
  max-width: 100%;
  min-width: 300px; 
}

.chart-container {
  width: 100%;
  height: 300px; /* Adjust height as needed */
}



@media (max-width: 425px) {


  .ant-card-head {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px; 
  }

  .ant-card-head-title {
    margin-bottom: 0px;
    font-size: 16px; /* Optional, in case font size is collapsing */
overflow: visible
    // display: block; /* Ensures visibility */
  }

  .ant-card-extra {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }

  .trends-value {
    font-size: 12px;
    //     flex-direction: column;
    // justify-content: center;
    // align-items: center;
    text-align: start;
    
  }
      .ant-switch {
      margin-left: 0px;
}

  .overview-body {
    padding: 0px;
    gap: 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: 0 !important;
    
  }

  .addwidget-btn {
    background-color: #e8ffec;
    color: #2c963d;
    border: none;
    margin-left: 0px;
    margin-bottom: 10px;
    
  }

}
@media (min-width: 320px) and (max-width: 426px){
  .ant-card-head{
  padding:4px !important;
}
}
@media (min-width: 427px) and (max-width: 770px) {
  #top-clients .recharts-surface{
    margin-top: -20% !important;
    width: 70% !important;
}
.compact_data{
    margin-top:-40% !important;
}
}


  .legend-container {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 16px;
    align-items: center;
  }

  .legend-item {
    display: flex;
    align-items: center;
    white-space: nowrap;
    font-size: 13px;
  }

  .legend-color {
    width: 10px;
    height: 10px;
    border-radius: 2px;
    margin-right: 6px;
    flex-shrink: 0;
  }

  .legend-label {
    color: #333;
  }


`;

const Dashboard = () => {
  const AIVehicleLists = useSelector(
    (state) => state?.authTracking?.AIVehicleLists,
  );
  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const fenceList = useSelector((state) => state?.authTracking?.fenceList);
  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList,
  );
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const [form] = Form.useForm();
  const [cardData, setCardData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isfilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedWidgets, setSelectedWidgets] = useState([]);
  const [userWidgets, setUserWidgets] = useState([]);
  const [filterCount, setFilterCount] = useState(0);
  const [formValues, setFormValues] = useState({
    Duration: "CurrentMonth",
    Daterange: [dayjs().startOf("month"), dayjs().endOf("month")],
  });
  const [trends, setTrends] = useState([]);

  const filteredWidgets = WidgetsAi?.filter((item) =>
    item?.name.toLowerCase()?.includes(searchText.toLowerCase()),
  );
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const exportAllowed = useMemo(
    () => hasPermission("AI_DASH", "EX"),
    [reduxPermissions],
  );
  const handleChange = (values) => {
    if (values?.includes("all")) {
      setSelectedWidgets(
        WidgetsAi?.map((item) => {
          return item?.value;
        }),
      );
    } else {
      setSelectedWidgets(values);
    }
  };

  const getTrends = async () => {
    setLoading(true);
    const { data } = await CALL_API("POST", `aidash/getAITrends`, {
      StartDate:
        dayjs(formValues?.Daterange?.[0]).format("YYYY-MM-DD") ||
        dayjs().format("YYYY-MM-DD"),
      EndDate:
        dayjs(formValues?.Daterange?.[1]).format("YYYY-MM-DD") ||
        dayjs().format("YYYY-MM-DD"),

      Duration: formValues?.Duration || "",
    });

    // const { data } = {
    //   message: "Successfully fetched data.",
    //   data: [
    //     {
    //       Slno: 0,
    //       Description: "Trips",
    //       PreviousValue: 0,
    //       CurrentValue: 147,
    //       PercentageValue: 16.7,
    //       Colour: "G",
    //     },
    //     {
    //       Slno: 1,
    //       Description: "Consignments Created vs Delivered",
    //       PreviousValue: 0,
    //       CurrentValue: 1852,
    //       PercentageValue: 8.25,
    //       Colour: "R",
    //     },
    //     {
    //       Slno: 2,
    //       Description: "Avg DeliveryTime",
    //       PreviousValue: 0,
    //       CurrentValue: "00:58",
    //       PercentageValue: 27.48,
    //       Colour: "G",
    //     },
    //     {
    //       Slno: 3,
    //       Description: "Clients",
    //       PreviousValue: 0,
    //       CurrentValue: 312,
    //       PercentageValue: 72.48,
    //       Colour: "R",
    //     },
    //     {
    //       Slno: 4,
    //       Description: "Loading Time",
    //       PreviousValue: 0,
    //       CurrentValue: 70,
    //       PercentageValue: "00.42",
    //       Colour: "R",
    //     },
    //     {
    //       Slno: 5,
    //       Description: "Loading Wait",
    //       PreviousValue: 0,
    //       CurrentValue: "00:24",
    //       PercentageValue: 25.5,
    //       Colour: "R",
    //     },
    //     {
    //       Slno: 6,
    //       Description: "OffLoading Time",
    //       PreviousValue: 0,
    //       CurrentValue: "00:30",
    //       PercentageValue: 30.2,
    //       Colour: "G",
    //     },
    //     {
    //       Slno: 7,
    //       Description: "OffLoading wait Time",
    //       PreviousValue: 0,
    //       CurrentValue: "4:00",
    //       PercentageValue: 20,
    //       Colour: "R",
    //     },
    //     {
    //       Slno: 8,
    //       Description: "Top Vehicles",
    //       PreviousValue: 898,
    //       CurrentValue: 12,
    //       PercentageValue: 12.2,
    //       Colour: "G",
    //     },
    //     {
    //       Slno: 9,
    //       Description: "Fuel per vehicle",
    //       PreviousValue: 0,
    //       CurrentValue: 21295,
    //       PercentageValue: 31.25,
    //       Colour: "G",
    //     },
    //     {
    //       Slno: 10,
    //       Description: "Distance per Vehicle",
    //       PreviousValue: 0,
    //       CurrentValue: 235641,
    //       PercentageValue: 34.39,
    //       Colour: "G",
    //     },
    //     {
    //       Slno: 11,
    //       Description: "Vehicle Mileage",
    //       PreviousValue: 0,
    //       CurrentValue: 11,
    //       PercentageValue: 20.2,
    //       Colour: "R",
    //     },
    //     {
    //       Slno: 12,
    //       Description: "Loading Cycle Times",
    //       PreviousValue: 0,
    //       CurrentValue: "51.82",
    //       PercentageValue: 30.7,
    //       Colour: "G",
    //     },
    //     {
    //       Slno: 13,
    //       Description: "OffLoading Cycle Times",
    //       PreviousValue: 0,
    //       CurrentValue: "56:40",
    //       PercentageValue: 50.5,
    //       Colour: "R",
    //     },
    //     {
    //       Slno: 14,
    //       Description: "Time After Loading",
    //       PreviousValue: 0,
    //       CurrentValue: "50:30",
    //       PercentageValue: 70.35,
    //       Colour: "G",
    //     },
    //     {
    //       Slno: 15,
    //       Description: "Time After Offloading",
    //       PreviousValue: 0,
    //       CurrentValue: "50:30",
    //       PercentageValue: 20.5,
    //       Colour: "R",
    //     },
    //     {
    //       Slno: 16,
    //       Description: "Carbon Footprint",
    //       PreviousValue: 0,
    //       CurrentValue: 51303,
    //       PercentageValue: 40.4,
    //       Colour: "G",
    //     },
    //     {
    //       Slno: 21,
    //       Description: "Delivery Rate",
    //       PreviousValue: 0,
    //       CurrentValue: 116490,
    //       PercentageValue: 20.1,
    //       Colour: "R",
    //     },
    //   ],
    // };
    setTrends(Array.isArray(data) ? data : []);
    setLoading(false);
  };

  const AddRemoveWidgets = async (widget, type) => {
    setLoading(true);
    const { data } = await CALL_API("POST", `aidash/AddRemoveWidget`, {
      MCID: userInfo?.MCID,
      UID: userInfo?.UID,
      Widgets: widget,
      Type: type,
    });
    getUserWidget();
    setLoading(false);
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsFilterModalOpen(false);
  };

  const getFilterCount = () => {
    const value = form.getFieldsValue() || {};
    const count = Object.values(value).filter(
      (val) => val && val.length !== 0,
    ).length;

    setFilterCount(count);
  };

  // useEffect(() => {
  //   getFilterCount();
  // }, [formValues]);

  // consignment Chart
  const [loading, setLoading] = useState();
  const [consignmentAndDeliveredData, setConsignmentAndDeliveredData] =
    useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;

  const getConsignmentAndDeliveryt = async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "POST",
        `aidash/getConsignmentAndDelivery`,
        {
          mcId: userInfo?.MCID,
          StartDate:
            dayjs(formValues?.Daterange?.[0]).format("YYYY-MM-DD") ||
            dayjs().format("YYYY-MM-DD"),
          EndDate:
            dayjs(formValues?.Daterange?.[1]).format("YYYY-MM-DD") ||
            dayjs().format("YYYY-MM-DD"),
          Cust: formValues?.consignor || 0,
          FID: formValues?.fence || "",
          Shipper: formValues?.transporter || 0,
          VehId: formValues?.vehicle || "",
          Device: formValues?.deviceid || "",
          Triptype: formValues?.tripType || 0,
          ShipmentType: formValues?.ShipmentType || 0,
          Duration: formValues?.Duration || "",
        },
      );
      setConsignmentAndDeliveredData(data);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };
  const maxPage = Math.floor(
    consignmentAndDeliveredData?.length / itemsPerPage,
  );

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, maxPage));
  };

  const paginatedData = Array.isArray(consignmentAndDeliveredData)
    ? consignmentAndDeliveredData.slice(
        currentPage * itemsPerPage,
        (currentPage + 1) * itemsPerPage,
      )
    : [];

  // trip chart
  const [tripPerVehicleData, setTripPerVehicleData] = useState([]);
  const [tripCurrentPage, setTripCurrentPage] = useState(0); // Ensure loading state is declared
  const tripItemsPerPage = 15;

  const getTripPerVehicle = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API("POST", `aidash/getTripPerVehicle`, {
        mcId: userInfo?.MCID,
        StartDate:
          dayjs(formValues?.Daterange?.[0]).format("YYYY-MM-DD") ||
          dayjs().format("YYYY-MM-DD"),
        EndDate:
          dayjs(formValues?.Daterange?.[1]).format("YYYY-MM-DD") ||
          dayjs().format("YYYY-MM-DD"),
        Cust: formValues?.consignor || 0,
        FID: formValues?.fence || "",
        Shipper: formValues?.transporter || 0,
        VehId: formValues?.vehicle || "",
        Triptype: formValues?.tripType || 0,
        driver: formValues?.driver || 0,
        Duration: formValues?.Duration || "",
        ShipmentType: formValues?.ShipmentType || 0,
      });
      const selectedVehId = formValues?.vehicle;
      let sorted = [...(data || [])];

      // PRIORITIZE selected vehicle at the top
      if (selectedVehId) {
        sorted.sort((a, b) => {
          if (a.VehId === selectedVehId) return -1;
          if (b.VehId === selectedVehId) return 1;
          return b.value - a.value; // normal descending sort
        });
      }
      setTripPerVehicleData(data || []);
    } catch (error) {
      console.error("Failed to fetch trip per vehicle data", error);
    } finally {
      setLoading(false);
    }
  };

  const tripMaxPage =
    Math.ceil(tripPerVehicleData.length / tripItemsPerPage) - 1;

  const tripHandlePrev = () => {
    setTripCurrentPage((prev) => Math.max(prev - 1, 0));
  };

  const tripHandleNext = () => {
    setTripCurrentPage((prev) => Math.min(prev + 1, tripMaxPage));
  };

  // Paginated data for current page
  const tripPaginatedData = tripPerVehicleData.slice(
    tripCurrentPage * tripItemsPerPage,
    (tripCurrentPage + 1) * tripItemsPerPage,
  );

  //client chart
  const [clientsData, setClientsData] = useState([]);
  const [total, setTotal] = useState(0);
  const [clientCurrentPage, setClientCurrentPage] = useState(0);
  const clientitemsPerPage = 15;
  const [liveDistanceData, setLiveDistanceData] = useState([]);

  const getRealTimeDistance = useCallback(async () => {
    try {
      let totalMileage = 0;

      // If vehicle selected → use it
      // Else → use all vehicles
      const selectedFGUID =
        formValues?.vehicle && formValues.vehicle.length > 0
          ? formValues.vehicle
          : AIVehicleLists.map((v) => v.FGUID);

      if (!selectedFGUID) return;

      const { data } = await CALL_API(
        "POST",
        "ai/trackinglink/LiveTelematicsDistance",
        {
          FGUID: selectedFGUID,
          StartDate: formValues?.Daterange?.[0]
            ? dayjs(formValues.Daterange[0]).format("YYYY-MM-DD")
            : dayjs().format("YYYY-MM-DD"),
          EndDate: formValues?.Daterange?.[1]
            ? dayjs(formValues.Daterange[1]).format("YYYY-MM-DD")
            : dayjs().format("YYYY-MM-DD"),
        },
      );

      totalMileage = Number(data.TotalMileage) || 0;

      setLiveDistanceData(totalMileage);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  }, [formValues?.vehicle, formValues?.Daterange, AIVehicleLists]);

  // const pollingRef = useRef(null);

  // const pollTrips = useCallback(async () => {
  //   // Always clear previous timeout before starting a new one
  //   if (pollingRef.current) {
  //     clearTimeout(pollingRef.current);
  //   }

  //   await getRealTimeDistance();

  //   pollingRef.current = setTimeout(() => {
  //     pollTrips();
  //   }, 5000);
  // }, [getRealTimeDistance]); // Make sure getRealTimeDistance is stable (useCallback if needed)

  // useEffect(() => {
  //   pollTrips(); // start polling

  //   return () => {
  //     if (pollingRef.current) {
  //       clearTimeout(pollingRef.current);
  //     }
  //   };
  // }, [formValues, pollTrips]);

  const getClients = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API("POST", `aidash/getToptenClient`, {
        mcId: userInfo?.MCID,
        StartDate:
          dayjs(formValues?.Daterange?.[0]).format("YYYY-MM-DD") ||
          dayjs().format("YYYY-MM-DD"),
        EndDate:
          dayjs(formValues?.Daterange?.[1]).format("YYYY-MM-DD") ||
          dayjs().format("YYYY-MM-DD"),
        Cust: formValues?.consignor || 0,
        FID: formValues?.fence || "",
        Shipper: formValues?.transporter || 0,
        VehId: formValues?.vehicle || "",
        Triptype: formValues?.tripType || 0,
        driver: formValues?.driver || "",
        Duration: formValues?.Duration || "",
        ShipmentType: formValues?.ShipmentType || 0,
      });

      const parsed =
        data?.map((item) => {
          const value = parseInt(item?.Val?.split("~")?.[1]) || 0;
          return {
            name: item?.Data,
            value,
          };
        }) || [];

      const totalValue = parsed.reduce((sum, curr) => sum + curr.value, 0);

      setClientsData(parsed);
      setTotal(totalValue);
    } catch (err) {
      console.error("Error fetching clients:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    getRealTimeDistance();
  }, [formValues?.vehicle, formValues?.Daterange, AIVehicleLists]);

  const clientMaxPage = Math.ceil(clientsData.length / clientitemsPerPage) - 1;

  const clientHandlePrev = () => {
    setClientCurrentPage((prev) => Math.max(prev - 1, 0));
  };

  const clientHandleNext = () => {
    setClientCurrentPage((prev) => Math.min(prev + 1, clientMaxPage));
  };

  const paginatedClients = clientsData.slice(
    clientCurrentPage * clientitemsPerPage,
    (clientCurrentPage + 1) * clientitemsPerPage,
  );

  //vehicle chart

  const [vehicleData, setVehicleData] = useState([]);
  const [vehiclePage, setVehiclePage] = useState(0);
  const vehicleitemsPerPage = 15; // Change based on your desired chunk size

  const getVehiclePerformance = async () => {
    setLoading(true);
    const { data } = await CALL_API(
      "POST",
      `aidash/getDistanceFuelMileagePerVehicle`,
      {
        mcId: userInfo?.MCID,
        StartDate:
          dayjs(formValues?.Daterange?.[0]).format("YYYY-MM-DD") ||
          dayjs().format("YYYY-MM-DD"),
        EndDate:
          dayjs(formValues?.Daterange?.[1]).format("YYYY-MM-DD") ||
          dayjs().format("YYYY-MM-DD"),
        Cust: formValues?.consignor || 0,
        FID: formValues?.fence || "",
        Shipper: formValues?.transporter || 0,
        VehId: formValues?.vehicle || "",
        Triptype: formValues?.tripType || 0,
        driver: formValues?.driver || 0,
        Duration: formValues?.Duration || "",
        ShipmentType: formValues?.ShipmentType || 0,
      },
    );
    const selectedVehId = formValues?.vehicle;
    let sorted = [...(data?.mileage || [])];

    // PRIORITIZE selected vehicle at the top
    if (selectedVehId) {
      sorted.sort((a, b) => {
        if (a.VehId === selectedVehId) return -1;
        if (b.VehId === selectedVehId) return 1;
        return b.value - a.value; // normal descending sort
      });
    }
    setVehicleData(data?.mileage || []);
    setLoading(false);
  };

  // Sort by Mileage DESC (or Distance / Fuel based on requirement)
  const sortedVehicleData = useMemo(() => {
    return [...vehicleData].sort((a, b) => b.Mileage - a.Mileage);
  }, [vehicleData]);

  // Calculate max pages
  const vehicleMaxPage =
    Math.ceil(sortedVehicleData.length / vehicleitemsPerPage) - 1;

  // Pagination control
  const handleVehiclePrev = () => {
    setVehiclePage((prev) => Math.max(prev - 1, 0));
  };

  const handleVehicleNext = () => {
    setVehiclePage((prev) => Math.min(prev + 1, vehicleMaxPage));
  };

  // Slice paginated data
  const paginatedVehicleData = useMemo(() => {
    if (!cardData?.performance) return [];
    return cardData?.performance.map(
      (item) =>{
        return {
          Data: item.REGNO,
          Fuel: item.AITotalFuel?.toFixed(2) ?? 0,
          Mileage: (item.liveDistance === 0 || item.AITotalFuel === 0 || item.AITotalFuel === null || item.liveDistance === null) ? 0 : item.liveDistance / item.AITotalFuel,
          Distance: item.liveDistance?.toFixed(2) ?? 0,
        }}
    ).filter(
      (item) => item.Distance !== 0 || item.Fuel !== 0 || item.Mileage !== 0
    );
  }, [cardData?.performance]);

  const formattedTime = (minutes) => {
    if (minutes == null || isNaN(minutes)) return "00:00";

    const days = Math.floor(minutes / (24 * 60));
    const hours = Math.floor((minutes % (24 * 60)) / 60);
    const mins = minutes % 60;

    if (days > 0) {
      return `${String(days).padStart(2, "0")}:${String(hours).padStart(
        2,
        "0",
      )}:${String(mins).padStart(2, "0")}`;
    } else {
      return `${String(hours).padStart(2, "0")}:${String(mins).padStart(
        2,
        "0",
      )}`;
    }
  };
  const getColour = (value) => {
    return trends?.find((item, index) => item?.Description === value)?.Colour;
  };

  const getpercentage = (value) => {
    const trendval = trends.find((item) => item.Description === value);
    const percentage = trendval?.PercentageValue;
    return percentage ?? "0%";
  };
  //Trackright AI
  const utilizationPercent = Math.round(
    (cardData?.vehicleUtilization / AIVehicleLists?.length) * 100,
  );
  const utilizationValue = `${utilizationPercent}% (${
    cardData?.vehicleUtilization || 0
  }/${AIVehicleLists?.length})`;
  const deliveryValue = `${cardData?.deliveryRate ?? 0}%`;
  const mileage = cardData?.totalFuel
    ? (cardData.totalDistance / cardData?.totalFuel).toFixed(2)
    : 0;
  const fuelExpected =
    liveDistanceData > 0 && cardData?.masterMileage > 0
      ? Number((liveDistanceData / cardData?.masterMileage).toFixed(2))
      : "0";
  // const mileageExpected =
  // fuelExpected === "N/A"
  //   ? "N/A"
  //   : fuelExpected !== 0
  //     ? Number((liveDistanceData / fuelExpected).toFixed(2))
  //     : 0;
  const mileageExpected = cardData?.masterMileage;

  const cardDatas = [
    {
      title: "Trips",
      value: cardData?.totalTrips ?? 0,
      // value: 900,
      subtitle: "Total Trips",
      background: "#FFE2E5",
      percent: getpercentage("Trips"),
      unit: "",
      number: 0,
      color: getColour("Trips"),
    },
    {
      title: "Consignments",
      value: cardData?.totalConsignments ?? 0,
      // value: 1755,
      subtitle: "Total Consignments",
      background: "#FFF4DE",
      number: 1,
      color: getColour("Consignments Created vs Delivered"),
      percent: getpercentage("Consignments Created vs Delivered"),
    },
    {
      title: "Delivery Time (AVG)",
      value: formattedTime(cardData?.totalAvgTripTime) ?? "00:00",
      //value: "19:35",
      subtitle: cardData?.totalAvgTripTime >= 1440 ? "DD:HH:MM" : "HH:MM",
      background: "#F3E8FF",
      number: 2,
      color: getColour("Avg DeliveryTime"),
      percent: getpercentage("Avg DeliveryTime"),
    },
    // {
    //   title: "Loading Time(AVG)",
    //   value: formattedTime(cardData?.totalLoadingTime) ?? "00:00",
    //   //value: "01:09",
    //   subtitle: cardData?.totalLoadingTime >= 1440 ? "DD:HH:MM" : "HH:MM",
    //   background: "#FFE2F7",
    //   number: 4,
    //   color: getColour("Loading Time"),
    //   percent: getpercentage("Loading Time"),
    // },
    // {
    //   title: "Loading Wait Time(AVG)",
    //   value: formattedTime(cardData?.totalLoadingWaitTime) ?? "00:00",
    //   //value: "01:34",
    //   subtitle: cardData?.totalLoadingWaitTime >= 1440 ? "DD:HH:MM" : "HH:MM",
    //   background: "#EBFFDE",
    //   number: 5,
    //   color: getColour("Loading Wait"),
    //   percent: getpercentage("Loading Wait"),
    // },
    // {
    //   title: "Offloading Time(AVG)",
    //   value: formattedTime(cardData?.totalOffloadingTime) ?? "00:00",
    //   //value: "21:00",
    //   subtitle: cardData?.totalOffloadingTime >= 1440 ? "DD:HH:MM" : "HH:MM",
    //   background: "#E8EDFF",
    //   number: 6,
    //   color: getColour("OffLoading Time"),
    //   percent: getpercentage("OffLoading Time"),
    // },
    // {
    //   title: "OffLoading Wait Time(AVG)",
    //   value: formattedTime(cardData?.totalOffloadingWaitTime) ?? "00:00",
    //   // value: "19:00",
    //   subtitle: cardData?.totalOffloadingWaitTime >= 1440 ? "DD:HH:MM" : "HH:MM",
    //   background: "#DCF8FC",
    //   number: 7,
    //   color: getColour("OffLoading wait Time"),
    //   percent: getpercentage("OffLoading wait Time"),
    // },
    {
      title: "Fuel ",
      value: cardData?.totalFuel ?? 0,
      // value: "21449",
      subtitle: "Litres",
      background: "#FFF4DE",
      number: 9,
      color: getColour("Fuel per vehicle"),
      percent: getpercentage("Fuel per vehicle"),
    },
    {
      title: "Distance",
      value: (cardData?.totalDistance ?? 0).toFixed(2),
      // value: "119451",
      subtitle: "KMS",
      background: "#F3E8FF",
      number: 10,
      color: getColour("Distance per Vehicle"),
      percent: getpercentage("Distance per Vehicle"),
    },
    {
      title: "Mileage",
      value: mileage,
      // value: "119451",
      subtitle: "KM/L",
      background: "#E8EDFF",
      number: 11,
      color: getColour("Vehicle Mileage"),
      percent: getpercentage("Vehicle Mileage"),
    },
    {
      title: "Loading Cycle Time (AVG)",
      value: formattedTime(cardData?.totalLoadingCycle) ?? "00:00",
      // value: "10:13",
      background: "#F3E8FF",
      subtitle: cardData?.totalLoadingCycle >= 1440 ? "DD:HH:MM" : "HH:MM",
      number: 12,
      color: getColour("Loading Cycle Times"),
      percent: getpercentage("Loading Cycle Times"),
    },
    {
      title: "Offloading Cycle",
      value: formattedTime(cardData?.totalOffLoadingCycle) ?? "00:00",
      // value: "10:40",
      background: "#EBFFDE",
      subtitle: cardData?.totalOffLoadingCycle >= 1440 ? "DD:HH:MM" : "HH:MM",
      number: 13,
      color: getColour("OffLoading Cycle Times"),
      percent: getpercentage("OffLoading Cycle Times"),
    },
    // {
    //   title: "Time After Loading(AVG)",
    //   value: formattedTime(cardData?.totalTimeAfterLoading) ?? "00:00",
    //   // value: "04:02",
    //   subtitle: cardData?.totalTimeAfterLoading >= 1440 ? "DD:HH:MM" : "HH:MM",
    //   background: "#E8EDFF",
    //   number: 14,
    //   color: getColour("Time After Loading"),
    //   percent: getpercentage("Time After Loading"),
    // },
    // {
    //   title: "Time After OffLoading(AVG)",
    //   value: formattedTime(cardData?.totalTimeAfterOffloading) ?? "00:00",
    //   //value: "04:08",
    //   subtitle: cardData?.totalTimeAfterOffloading >= 1440 ? "DD:HH:MM" : "HH:MM",
    //   background: "#DCF8FC",
    //   number: 15,
    //   color: getColour("Time After Offloading"),
    //   percent: getpercentage("Time After Offloading"),
    // },
    {
      title: "Carbon Footprint",
      value: Number(Number(cardData?.totalCarbonFootprint || 0).toFixed(2)),
      // value: "60388.9",
      subtitle: "KgC02",
      background: " #DDF6E1",
      number: 16,
      leafimg: <LeafMud />,
      color: getColour("Carbon Footprint"),
      percent: getpercentage("Carbon Footprint"),
    },
    {
      title: "Delivery Rate",
      value: deliveryValue,
      // value: "60388.9",
      background: " #FFF4DE",
      number: 17,
      color: getColour("Delivery Rate"),
      percent: getpercentage("Delivery Rate"),
    },
    {
      title: "Vehicle Utilization",
      value: utilizationValue,
      // value: "60388.9",
      background: " #FFE2F7",
      number: 18,
      color: getColour("Vehicle Utilization"),
      percent: getpercentage("Vehicle Utilization"),
    },
    {
      title: "Live Telematics Distance",
      value: liveDistanceData,
      subtitle: "KMS",
      background: " #DCF8FC",
      number: 19,
      color: getColour("Live Telematics Distance"),
      percent: getpercentage("Live Telematics Distance"),
    },
    {
      title: "Fuel Expected",
      value: fuelExpected,
      subtitle: "Liters",
      background: "#FFF4DE",
      number: 20,
      color: getColour("Fuel Expected"),
      percent: getpercentage("Fuel Expected"),
    },
    {
      title: "Mileage - Expected",
      value: mileageExpected,
      subtitle: "KM/L",
      background: "#DCEBFC",
      number: 21,
      color: getColour("Mileage - Expected"),
      percent: getpercentage("Mileage - Expected"),
    },
    {
      title: "Empty KMs",
      value: Math.max(0, liveDistanceData - (cardData?.totalDistance || 0)),
      subtitle: "Kms",
      background: "#F3E8FF",
      number: 22,
      color: getColour("Empty KMs"),
      percent: getpercentage("Empty KMs"),
    },
  ];

  const vehicleMileagePerfomance = useMemo(() => {
    // const totalFuel = Number(cardData?.totalFuel) || 0;
    // const expectedFuel = Number(fuelExpected) || 0;

    // const parseValue = (value) => {
    //   if (
    //     value === "N/A" ||
    //     value === null ||
    //     value === undefined ||
    //     value === ""
    //   ) {
    //     return 0;
    //   }

    //   const parsed = Number(value);

    //   return Number.isFinite(parsed) ? parsed : 0;
    // };
 if (!cardData?.performance) return [];
    return cardData?.performance  
      .map((item) => {
        // const mileage = parseValue(item.Mileage);

        return {
          vehicleName: item.REGNO,
          // actualMileage: totalFuel > 0 ? mileage / totalFuel : 0,
          // expectedMileage: expectedFuel > 0 ? mileage / expectedFuel : 0,
          actualMileage: item.ActualMileage?.toFixed(2) ?? 0,
          expectedMileage: item.masterMileage?.toFixed(2) ?? 0,
        };
      })
      .filter(
        (item) =>
          !(item.actualMileage === 0 && item.expectedMileage === 0)
      );
  }, [cardData?.performance]);

  const vehicleFuelPerfomance = useMemo(() => {
    // const totalFuel = Number(cardData?.totalFuel) || 0;
    // const expectedFuel = Number(fuelExpected) || 0;
    if (!cardData?.performance) return [];
    return cardData?.performance.map((item) => {
      // const mileage = Number(item.Mileage) || 0;

      return {
        vehicleName: item.REGNO,
        totalFuel: item.AITotalFuel?.toFixed(2) ?? 0,
        expectedFuel: item.ExpectedFuel?.toFixed(2) ?? 0,
      };
    }).filter(
      (item) => !(item.totalFuel === 0 && item.expectedFuel === 0)
    );
  }, [cardData?.performance]);


  const mergedCardDatas = cardDatas.map((card) => {
    const matchingTrend = trends?.find((trend) => trend?.Slno === card.number);

    return {
      ...card,
      percent: matchingTrend ? `${matchingTrend.PercentageValue}%` : "",
      colour: matchingTrend?.Colour?.trim() || "",
    };
  });

  const Duration = [
    { label: "Current Month", value: "CurrentMonth" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
  ];

  const getUserWidget = async () => {
    const { data } = await CALL_API("POST", `/aidash/getUserWidgets`, {
      mcId: userInfo?.MCID,
      userId: userInfo?.UID,
    });
    //  setUserWidgets(data?.[0]?.AIDASHWIDGETS.split(",").map(Number));
    setUserWidgets(
      data?.[0]?.AIDASHWIDGETS
        ? data[0].AIDASHWIDGETS.split(",").map(Number)
        : [],
    );
  };

  const getCardData = async () => {
    const { data } = await CALL_API("POST", `aidash/getTotalDashData`, {
      mcId: userInfo?.MCID,
      StartDate:
        dayjs(formValues?.Daterange?.[0]).format("YYYY-MM-DD") ||
        dayjs().format("YYYY-MM-DD"),
      EndDate:
        dayjs(formValues?.Daterange?.[1]).format("YYYY-MM-DD") ||
        dayjs().format("YYYY-MM-DD"),
      Cust: formValues?.consignor || 0,
      FID: formValues?.fence || "",
      Shipper: formValues?.transporter || 0,
      VehId: formValues?.vehicle || "",
      Triptype: formValues?.tripType || 0,
      driver: formValues?.driver || 0,
      // Duration: formValues?.Duration || "",
      ShipmentType: formValues?.ShipmentType || 0,
      FVehicleName: AIVehicleLists?.find((v) => v.FGUID === formValues?.vehicle)?.FVehicleName || "",
    });
    setCardData(data);
  };

  useEffect(() => {
    getUserWidget();
    getCardData();
    getTripPerVehicle();
    getVehiclePerformance();
    getClients();
    getConsignmentAndDeliveryt();
  }, [formValues.Daterange, formValues.vehicle, formValues.driver, formValues.ShipmentType, formValues.tripType, formValues.consignor, formValues.fence, formValues.transporter]);

  const [cardOrder, setCardOrder] = useState(
    cardDatas.map((card) => card.number),
  );
  const [dragIndex, setDragIndex] = useState(null);

  const handleDragStart = (index) => {
    setDragIndex(index);
  };

  const handleDrop = (dropIndex) => {
    if (dragIndex === null || dragIndex === dropIndex) return;

    const newOrder = [...cardOrder];
    const draggedItem = newOrder[dragIndex];

    newOrder.splice(dragIndex, 1);
    newOrder.splice(dropIndex, 0, draggedItem);
    setCardOrder(newOrder);
    setDragIndex(null);
  };

  useEffect(() => {
    setSelectedWidgets(userWidgets?.map((item) => item));
  }, [userWidgets]);
  useEffect(() => {
    const duration = formValues?.Duration;
    let range = [null, null];

    if (duration === "last_month") {
      range = [
        dayjs().subtract(1, "month").startOf("month"),
        dayjs().subtract(1, "month").endOf("month"),
      ];
    } else if (duration === "CurrentMonth") {
      range = [dayjs().startOf("month"), dayjs().endOf("month")];
    } else if (duration === "current_year") {
      range = [dayjs().startOf("year"), dayjs().endOf("year")];
    } else if (duration === "today") {
      range = [dayjs(), dayjs()];
    } else if (duration === "---") {
      range = [null, null];
    }

    form.setFieldsValue({
      Daterange: range,
    });

    setFormValues((prev) => ({
      ...prev,
      Daterange: range,
    }));
  }, [formValues?.Duration]);

  const CustomHoverBar = (props) => {
    const { x, y, width, height, fill } = props;
    const [hovered, setHovered] = useState(false);

    const shrink = hovered ? 6 : 0; // Shrink width by 6px when hovered

    return (
      <rect
        x={x + shrink / 2} // shift to center after shrinking
        y={y}
        width={width - shrink}
        height={height}
        fill={fill}
        rx={4}
        ry={4}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{ transition: "all 0.3s ease-in-out" }}
      />
    );
  };

  // const ConsigndeliveryChart = ({ data }) => {
  //   return (
  //     <Spin spinning={loading}>
  //       <ResponsiveContainer
  //         width="95%"
  //         height={325}
  //         id="consignment and delivered"
  //       >
  //         <BarChart
  //           data={data}
  //           margin={{
  //             top: 10,
  //             right: 0,
  //             left: 0,
  //             bottom: 5,
  //           }}
  //           barCategoryGap="0%"
  //           barGap={0}
  //           // barSize={14}
  //         >
  //           <Legend
  //             layout="horizontal"
  //             align="center"
  //             verticalAlign="top"
  //             wrapperStyle={{
  //               position: "absolute",
  //               top: 0,
  //               left: "50%",
  //               transform: "translateX(-50%)",
  //               borderRadius: "5px",
  //             }}
  //           />
  //           <CartesianGrid stroke="none" />
  //           <XAxis
  //             dataKey="Data"
  //             axisLine={false}
  //             tickLine={false}
  //             tick={{ fontSize: 10.5, fill: "#666" }}
  //           />

  //           <YAxis axisLine={false} tickLine={false} />
  //           <Tooltip />
  //           <Bar
  //             dataKey="Val"
  //             name="Consignments"
  //             fill="#E4A400"
  //             radius={[4, 4, 0, 0]}
  //             barSize={35}
  //           />
  //           <Bar
  //             dataKey="D1"
  //             name="Delivered"
  //             fill="#00BC13"
  //             radius={[4, 4, 0, 0]}
  //             barSize={35}
  //           />
  //         </BarChart>
  //       </ResponsiveContainer>
  //     </Spin>
  //   );
  // };
  const ConsigndeliveryChart = ({ data }) => {
    const safeData = Array.isArray(data) ? data : [];
    return (
      <Spin spinning={loading}>
        <ResponsiveContainer
          width="95%"
          height={325}
          id="consignment and delivered"
        >
          <BarChart
            data={safeData}
            margin={{
              top: 10,
              right: 0,
              left: 0,
              bottom: 5,
            }}
            barCategoryGap="0%"
            barGap={0}
          >
            <Legend
              layout="horizontal"
              align="center"
              verticalAlign="top"
              wrapperStyle={{
                position: "absolute",
                top: 0,
                left: "50%",
                transform: "translateX(-50%)",
                borderRadius: "5px",
              }}
            />
            <CartesianGrid stroke="none" />
            <XAxis
              dataKey="Data"
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 9.5, fill: "#666" }}
              // tick={false}
              tickFormatter={(value) => {
                const [day, month, year] = value.split("-").map(Number);
                if (!day || !month || !year) return "";
                const monthNames = [
                  "Jan",
                  "Feb",
                  "Mar",
                  "Apr",
                  "May",
                  "Jun",
                  "Jul",
                  "Aug",
                  "Sep",
                  "Oct",
                  "Nov",
                  "Dec",
                ];

                const monthName = monthNames[month - 1];
                console.log("FormattedTick", monthName);

                return window.innerWidth >= 320 && window.innerWidth <= 426
                  ? `${day}-${monthName}`
                  : `${day}/${month}/${year}`;
              }}
            />
            <YAxis axisLine={false} tickLine={false} />
            <Tooltip />
            <Bar
              dataKey="Val"
              name="Consignments"
              fill="#E4A400"
              radius={[4, 4, 0, 0]}
              barSize={35}
            />
            <Bar
              dataKey="D1"
              name="Delivered"
              fill="#00BC13"
              radius={[4, 4, 0, 0]}
              barSize={35}
            />
          </BarChart>
        </ResponsiveContainer>
      </Spin>
    );
  };

  const TripPerVehicleChart = ({ data }) => {
    const containerRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(0);

    useEffect(() => {
      if (containerRef.current)
        setContainerWidth(containerRef.current.offsetWidth);
      const handleResize = () => {
        if (containerRef.current)
          setContainerWidth(containerRef.current.offsetWidth);
      };
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    const chartWidth = Math.max(data?.length * 70, containerWidth);

    return (
      <Spin spinning={loading}>
        <div
          ref={containerRef}
          style={{
            display: "flex",
            width: "100%",
            overflow: "hidden",
          }}
        >
          {/* Fixed Y-axis */}
          <div
            style={{
              width: 60,
              height: 380,
              background: "#fff",
              borderRight: "1px solid #eee",
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: "6px",
            }}
          >
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={data}>
                <YAxis
                  dataKey="Val"
                  tickLine={false}
                  axisLine={false}
                  width={40}
                  tick={{ fontSize: 11, fill: "#666", textAnchor: "end" }}
                  domain={[0, "auto"]}
                />
              </BarChart>
            </ResponsiveContainer>
          </div>

          {/* Scrollable Bars + X-axis */}
          <div
            style={{
              overflowX: "auto",
              flex: 1,
              msOverflowStyle: "none",
              scrollbarWidth: "none",
            }}
          >
            <div
              style={{
                width: chartWidth,
                height: 380,
              }}
            >
              <ResponsiveContainer width="100%" height="100%">
                <BarChart
                  data={data}
                  margin={{ top: 20, right: 20, left: 0, bottom: 20 }}
                  barSize={28}
                >
                  <CartesianGrid vertical={false} horizontal={true} />
                  <XAxis
                    dataKey="Data"
                    tickLine={false}
                    axisLine={false}
                    tick={{ fontSize: 11, fill: "#666" }}
                  />
                  <Tooltip />
                  <Bar
                    dataKey="Val"
                    name="Trips"
                    fill="#0E9CD4"
                    radius={[4, 4, 0, 0]}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>

        {/* Hide scrollbar (for Webkit browsers) */}
        <style>
          {`
            div::-webkit-scrollbar {
              display: none;
            }
          `}
        </style>
      </Spin>
    );
  };

  const COLORS = [
    "#7DFF8A",
    "#8175FF",
    "#0065BC",
    "#00EA98",
    "#00D2F2",
    "#007EEA",
    "#FF8664",
    "#FFE478",
    "#FF5BB2",
    "#C859FF",
  ];

  const isMobile = window.innerWidth < 600; // Detect mobile screen

  const SMALL_THRESHOLD = 15;

  const TopClientsChart = ({ data, total }) => {
    const hasLessThanOnePercent = data.some(
      (item) => ((item.value / total) * 100) < 1
    );

    const useTooltipChart =
      data.length > SMALL_THRESHOLD || hasLessThanOnePercent;

    return useTooltipChart ? (
      <TopClientsTooltipChart data={data} total={total} />
    ) : (
      <TopClientsInlineChart data={data} total={total} />
    );
  };

 const TopClientsInlineChart = ({ data, total }) => {
   const renderCustomLabel = ({
     cx,
     cy,
     midAngle,
     outerRadius,
     payload,
     percent,
     index,
   }) => {
     if (!payload || payload.value === 0) return null;

     const RADIAN = Math.PI / 180;

     const radius = outerRadius + 25;

     const isLeft = midAngle > 90 && midAngle < 270;

     const bx = cx + radius * Math.cos(-midAngle * RADIAN);
     const by = cy + radius * Math.sin(-midAngle * RADIAN);

     const ex = bx + (isLeft ? -70 : 70);

     return (
       <g>
         <polyline
           points={`
            ${cx + outerRadius * Math.cos(-midAngle * RADIAN)},
            ${cy + outerRadius * Math.sin(-midAngle * RADIAN)}
            ${bx},${by}
            ${ex},${by}
          `}
           stroke="#BEBEBE"
           fill="none"
           strokeWidth={1.5}
         />

         <circle cx={ex} cy={by} r={6} fill={COLORS[index % COLORS.length]} />

         <text
           x={ex + (isLeft ? -12 : 12)}
           y={by + 4}
           textAnchor={isLeft ? "end" : "start"}
           fill="#5F6D8C"
           fontSize={11}
           fontWeight={500}
         >
           {`${payload.name} (${(percent * 100).toFixed(1)}%)`}
         </text>
       </g>
     );
   };

   return (
     <div style={{ height: 400 }}>
       <ResponsiveContainer width="100%" height="100%">
         <PieChart margin={{ top: 80, right: 150, bottom: 80, left: 150 }}>
           <Pie
             data={data}
             cx="50%"
             cy="50%"
             innerRadius={70}
             outerRadius={100}
             dataKey="value"
             labelLine={false}
             label={renderCustomLabel}
             minAngle={2}
             paddingAngle={1}
           >
             {data.map((entry, index) => (
               <Cell key={index} fill={COLORS[index % COLORS.length]} />
             ))}
           </Pie>

           <Tooltip />

           {/* <text
             x="50%"
             y="48%"
             textAnchor="middle"
             dominantBaseline="middle"
             fontSize={22}
             fontWeight="bold"
           >
             {total}
           </text>

           <text
             x="50%"
             y="54%"
             textAnchor="middle"
             dominantBaseline="middle"
             fontSize={14}
             fontWeight="bold"
           >
             Trips
           </text> */}
         </PieChart>
       </ResponsiveContainer>
     </div>
   );
 };

 const TopClientsTooltipChart = ({ data, total }) => (
   <>
     <div style={{ height: 400 }}>
       <ResponsiveContainer width="100%" height="100%">
         <PieChart>
           <Pie
             data={data}
             cx="50%"
             cy="50%"
             innerRadius={70}
             outerRadius={100}
             dataKey="value"
             label={false}
             labelLine={false}
             minAngle={1}
             paddingAngle={1}
           >
             {data.map((entry, index) => (
               <Cell key={index} fill={COLORS[index % COLORS.length]} />
             ))}
           </Pie>

           <Tooltip formatter={(value, name) => [value, name]} />

           {/* <text
             x="50%"
             y="48%"
             textAnchor="middle"
             dominantBaseline="middle"
             fontSize={22}
             fontWeight="bold"
           >
             {total}
           </text> */}

           {/* <text
             x="50%"
             y="54%"
             textAnchor="middle"
             dominantBaseline="middle"
             fontSize={14}
             fontWeight="bold"
           >
             Trips
           </text> */}
         </PieChart>
       </ResponsiveContainer>
     </div>

     <div className="legend-container mx-2 mx-md-5 my-2">
       {data.map((item, index) => (
         <div key={index} className="legend-item">
           <span
             className="legend-color"
             style={{
               backgroundColor: COLORS[index % COLORS.length],
             }}
           />
           <span className="legend-label">
             {item.name}{" "}
             <strong>{((item.value / total) * 100).toFixed(2)}%</strong>
           </span>
         </div>
       ))}
     </div>
   </>
 );

  const VehiclePerformanceChart = ({ data }) => {
    const containerRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(0);

    useEffect(() => {
      if (containerRef.current)
        setContainerWidth(containerRef.current.offsetWidth);
      const handleResize = () => {
        if (containerRef.current)
          setContainerWidth(containerRef.current.offsetWidth);
      };
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    const chartWidth = Math.max(data?.length * 80, containerWidth - 60); // minus Y-axis width

    // Compute min/max for Y-axis
    const allValues = data
      .flatMap((item) => [
        selectedWidgets?.includes(9) ? item.Fuel : null,
        selectedWidgets?.includes(10) ? item.Distance : null,
        selectedWidgets?.includes(11) ? item.Mileage : null,
      ])
      .filter((v) => v !== null);

    const minValue = Math.min(...allValues, 0);
    const maxValue = Math.max(...allValues, 10);

    return (
      <Spin spinning={loading}>
        <div
          ref={containerRef}
          style={{ display: "flex", width: "100%", background: "#fff" }}
        >
          {/* Fixed Y-axis */}
          <div
            style={{
              width: 60,
              height: 325,
              borderRight: "1px solid #eee",
              position: "sticky",
              left: 0,
              background: "#fff",
              zIndex: 10,
            }}
          >
            <ResponsiveContainer width="100%" height="100%">
              <ComposedChart data={data}>
                <YAxis
                  axisLine={false}
                  tickLine={false}
                  tick={{ fontSize: 11, fill: "#666", textAnchor: "end" }}
                  width={60}
                  domain={[minValue, maxValue]} // Sync scale
                />
              </ComposedChart>
            </ResponsiveContainer>
          </div>

          {/* Scrollable chart area */}
          <div style={{ overflowX: "auto", flex: 1 }}>
            <div style={{ width: chartWidth, height: 325 }}>
              <ResponsiveContainer width="100%" height="100%">
                <ComposedChart
                  data={data}
                  margin={{ top: 40, right: 30, left: 0, bottom: 10 }}
                  barCategoryGap="25%"
                  barGap={0}
                  style={{ cursor: "pointer" }}
                >
                  <Legend
                    layout="horizontal"
                    align="center"
                    verticalAlign="top"
                    wrapperStyle={{
                      position: "absolute",
                      top: 0,
                      left: "50%",
                      transform: "translateX(-50%)",
                      borderRadius: "5px",
                    }}
                  />
                  <CartesianGrid vertical={false} horizontal={true} />
                  <XAxis
                    dataKey="Data"
                    axisLine={false}
                    tickLine={false}
                    tick={{ fontSize: 10, fill: "#666" }}
                  />
                  <Tooltip />
                  {selectedWidgets?.includes(9) && (
                    <Bar
                      dataKey="Fuel"
                      name="Fuel (L)"
                      fill="#68DCFF"
                      radius={[4, 4, 0, 0]}
                      barSize={16}
                    />
                  )}
                  {selectedWidgets?.includes(10) && (
                    <Bar
                      dataKey="Distance"
                      name="Distance (Km)"
                      fill="#FF73DB"
                      radius={[4, 4, 0, 0]}
                      barSize={16}
                    />
                  )}
                  {selectedWidgets?.includes(11) && (
                    <Line
                      type="basis"
                      dataKey="Mileage"
                      name="Mileage (Km/L)"
                      stroke="#E4A400"
                      dot={false}
                    />
                  )}
                </ComposedChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>

        <style>{`div::-webkit-scrollbar { display: none; }`}</style>
      </Spin>
    );
  };

  const VehicleMileagePerformanceChart = ({ data }) => {
    const safeData = Array.isArray(data) ? data : [];

     // Compute min/max for Y-axis
    const allValues = data
      .flatMap((item) => [
        item.actualMileage,
        item.expectedMileage,
      ])
      .filter((v) => v !== null);

    const minValue = Math.min(...allValues, 0);
    const maxValue = Math.max(...allValues, 10);

    return (
      <Spin spinning={loading}>
        <ResponsiveContainer width="95%" height={325}>
          <BarChart
            data={safeData}
            margin={{ top: 10, right: 0, left: 0, bottom: 5 }}
          >
            <Legend layout="horizontal" align="center" verticalAlign="top" />

            <CartesianGrid stroke="none" />

            <XAxis
              dataKey="vehicleName"
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 10, fill: "#666" }}
            />

            <YAxis axisLine={false} tickLine={false}   domain={[minValue, maxValue]}/>
            {safeData.length > 0 && <Tooltip />}

            <Bar
              dataKey="actualMileage"
              name="Actual Mileage (Km/L)"
              fill="#FFAA0D"
              radius={[4, 4, 0, 0]}
              barSize={35}
              activeBar={safeData.length > 0 ? undefined : false}
            />

            <Bar
              dataKey="expectedMileage"
              name="Expected Mileage (Km/L)"
              fill="#1975FF"
              radius={[4, 4, 0, 0]}
              barSize={35}
              activeBar={safeData.length > 0 ? undefined : false}
            />
          </BarChart>
        </ResponsiveContainer>
      </Spin>
    );
  };

  const VehicleFuelPerformanceChart = ({ data }) => {
    const safeData = Array.isArray(data) ? data : [];

    // Compute min/max for Y-axis
    const allValues = data
      .flatMap((item) => [
        item.totalFuel,
        item.expectedFuel,
      ])
      .filter((v) => v !== null);

    const minValue = Math.min(...allValues, 0);
    const maxValue = Math.max(...allValues, 10);

    return (
      <Spin spinning={loading}>
        <ResponsiveContainer width="95%" height={325}>
          <BarChart
            data={safeData}
            margin={{ top: 10, right: 0, left: 0, bottom: 5 }}
            barCategoryGap="10%"
          >
            <Legend layout="horizontal" align="center" verticalAlign="top" />

            <CartesianGrid stroke="none" />

            <XAxis
              dataKey="vehicleName"
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 10, fill: "#666" }}
            />

            <YAxis axisLine={false} tickLine={false}   domain={[minValue, maxValue]}/>
            {safeData.length > 0 && <Tooltip />}

            <Bar
              dataKey="totalFuel"
              name="Actual Fuel (L)"
              fill="#68DCFF"
              radius={[4, 4, 0, 0]}
              barSize={30}
              activeBar={safeData.length > 0 ? undefined : false}
            />

            <Bar
              dataKey="expectedFuel"
              name="Expected (L)"
              fill="#FF8664"
              radius={[4, 4, 0, 0]}
              barSize={30}
              activeBar={safeData.length > 0 ? undefined : false}
            />
          </BarChart>
        </ResponsiveContainer>
      </Spin>
    );
  };

  const [isSwitchChecked, setIsSwitchChecked] = useState(false);

  const onChange = (checked) => {
    setIsSwitchChecked(checked);
    getTrends();
  };

  const chartHeight =
    window.innerWidth >= 321 && window.innerWidth <= 425 ? 250 : 500;

  return (
    <>
      {/* <Row className="Button-Wrap">
      <div style={{ display: "flex", gap: "8px" }}>
            <DashboardButton style={{ minWidth: 160,minHeight:50 }} >TrackRightAI</DashboardButton>
            <DashboardButton style={{ minWidth: 160,minHeight:50  }} onClick={() => navigate("/container-dashboard")}>Container Tracking</DashboardButton>
            <DashboardButton style={{ minWidth: 160,minHeight:50 }} onClick={() => navigate("/AIDashboard")}>Trackright AI+</DashboardButton>
      </div>
      </Row> */}
      <div>
        <DashboardNav></DashboardNav>
      </div>
      <div className="dashboard-content">
        <Styledashboard>
          <div className="overview-body p-0">
            <div
              style={{ backgroundColor: "white" }}
              bordered={false}
              className="overview-body track-overview"
            >
              <div bordered={false} className="overview-body track-overview">
                {
                  <Card
                    className="card_responsive"
                    style={{
                      borderTopLeftRadius: isMobile ? "0px" : "8px",
                      borderTopRightRadius: isMobile ? "0px" : "8px",
                      borderBottomLeftRadius: "8px",
                      borderBottomRightRadius: "8px",
                      overflow: "visible",
                      boxShadow: "none",
                      padding: "0px",
                      marginBottom: "16px",
                      border: "none",
                    }}
                    bodyStyle={{
                      borderBottomLeftRadius: "0px",
                      borderBottomRightRadius: "0px",
                      overflow: "visible",
                      paddingBottom: "",
                    }}
                  >
                    {/* --- Filters Row --- */}
                    <div
                      className="overview-filters"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        flexWrap: "nowrap", // prevents items from breaking into a new line
                        gap: "10px",
                        marginBottom: "16px",
                        overflowX: "auto", // allows horizontal scroll on small screens
                        paddingBottom: "4px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          minWidth: "max-content", // prevents shrinkage
                        }}
                      >
                        <span
                          className="trends-value"
                          style={{ color: "#5F6D8C", fontSize: "18px" }}
                        >
                          Trends
                        </span>
                        <Switch onChange={onChange} color="#31AB46" />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          minWidth: "max-content", // makes sure buttons don’t shrink
                        }}
                      >
                         <div className="dropstyle">
                            <Select
                              placeholder="Custom Range"
                              value={formValues?.Duration}
                              onChange={(value) =>
                                setFormValues((prev) => ({
                                  ...prev,
                                  Duration: value,
                                }))
                              }
                            >
                              {Duration.map((item) => (
                                <Option key={item.value} value={item.value}>
                                  {item.label}
                                </Option>
                              ))}
                            </Select>
                          </div>

                          <div className="dropstyle1">
                            <Space direction="vertical" size={12}>
                              <RangePicker
                                value={formValues?.Daterange}
                                onChange={(value) =>
                                  setFormValues((prev) => ({
                                    ...prev,
                                    Daterange: value,
                                  }))
                                }
                              />
                            </Space>
                          </div>
                        <ButtonFilled
                          className="addwidget-btn"
                          onClick={() => {
                            setIsModalOpen(true);
                          }}
                          style={{
                            cursor: exportAllowed ? "pointer" : "not-allowed",
                          }}
                        >
                          + Add Widget
                        </ButtonFilled>

                        <div className="Iconbg">
                          <img
                            src={FilterIcon}
                            alt="Filter Icon"
                            width={20}
                            onClick={() => setIsFilterModalOpen(true)}
                          />
                        </div>
                      </div>
                    </div>
                    <Spin spinning={loading}>
                      <Row gutter={[16, 16]}>
                        {cardOrder
                          .filter((num) => selectedWidgets.includes(num))
                          .map((num) =>
                            cardDatas.find((card) => card.number === num),
                          )
                          .map((item, index) => (
                            <Col
                              xs={12}
                              sm={12}
                              md={6}
                              lg={6}
                              key={item.number}
                              draggable
                              onDragStart={() => handleDragStart(index)}
                              onDragOver={(e) => e.preventDefault()}
                              onDrop={() => handleDrop(index)}
                              style={{ cursor: "grab" }}
                            >
                              <Card
                                className="card_paddingissue"
                                title={
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      gap: "8px",
                                      width: "100%",
                                      overflow: "hidden",
                                      paddingBottom: "6px",
                                    }}
                                  >
                                    <span
                                      style={
                                        window.innerWidth >= 320 &&
                                        window.innerWidth <= 426
                                          ? {
                                              // whiteSpace:"nowrap",
                                              fontSize: "13px",
                                              padding: "4px",
                                              //  overflowWrap: "break-word",
                                              textWrap: "wrap",
                                            }
                                          : {
                                              fontSize: "15px",
                                              fontWeight: 500,
                                              lineHeight: 1.3,
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              flex: 1,
                                              minWidth: 0,
                                              whiteSpace: "normal",
                                              // overflowWrap: "break-word",
                                            }
                                      }
                                      className="card-title-text"
                                      title={item.title}
                                    >
                                      {item.title}
                                      {item.leafimg && (
                                        <span className="ms-2">
                                          {item.leafimg}
                                        </span>
                                      )}
                                    </span>

                                    <div style={{ flexShrink: 0 }}>
                                      <CloseOutlined
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          AddRemoveWidgets(`${item.number}`, 0)
                                        }
                                      />
                                    </div>
                                  </div>
                                }
                                bordered={false}
                                style={{
                                  backgroundColor: item.background,
                                  textAlign: "left",
                                  overflow: "hidden",
                                  wordBreak: "break-word",
                                  height: "100%", // ✅ Full block height (matches siblings)
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                }}
                                bodyStyle={{
                                  paddingTop: 0,
                                  flexGrow: 1,
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div
                                  style={{
                                    textAlign: "left",
                                    overflow: "hidden",
                                    flexGrow: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <div
                                    className="stats-card"
                                    style={{
                                      textAlign: "left",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <h4
                                      style={
                                        window.innerWidth >= 320 &&
                                        window.innerWidth <= 426
                                          ? {
                                              fontSize: "17px",
                                              padding: "4px",
                                              textWrap: "wrap",
                                            }
                                          : {
                                              margin: 0,
                                              textAlign: "left",
                                            }
                                      }
                                      title={item.value}
                                    >
                                      {item.value}
                                    </h4>
                                    <p
                                      style={
                                        window.innerWidth >= 320 &&
                                        window.innerWidth <= 426
                                          ? {
                                              fontSize: "14px",
                                              padding: "4px",
                                              textWrap: "wrap",
                                              margin: "1px",
                                            }
                                          : {
                                              margin: "4px 0",
                                              textAlign: "left",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }
                                      }
                                      title={item.subtitle}
                                    >
                                      {item.subtitle}
                                    </p>
                                  </div>

                                  {isSwitchChecked && (
                                    <div
                                      className="status_card1"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "flex-start",
                                        gap: "6px",
                                        overflow: "hidden",
                                      }}
                                    >
                                      {item.color && (
                                        <p
                                          className={
                                            item.color === "G"
                                              ? "text-success"
                                              : item.color === "R"
                                                ? "text-danger"
                                                : ""
                                          }
                                          style={{
                                            margin: 0,
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                          }}
                                        >
                                          ({item.percent}%)
                                        </p>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </Card>
                            </Col>
                          ))}
                      </Row>
                    </Spin>
                  </Card>
                }
                {/* --- Main Content --- */}
                {/* <Card>
              <Spin spinning={loading}>
                <Row gutter={[16, 16]}>
                  {cardOrder
                    .filter((num) => selectedWidgets.includes(num))
                    .map((num) => cardDatas.find((card) => card.number === num))
                    .map((item, index) => (
                      <Col
                        xs={12}
                        sm={12}
                        md={6}
                        lg={6}
                        key={item.number}
                        draggable
                        onDragStart={() => handleDragStart(index)}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={() => handleDrop(index)}
                        style={{ cursor: "grab" }}
                      >
                        <Card
                          title={
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: "8px",
                                width: "100%",
                                overflow: "hidden",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "15px",
                                  fontWeight: 500,
                                  lineHeight: 1.3,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  flex: 1,
                                  minWidth: 0,
                                  whiteSpace: "normal",
                                  overflowWrap: "break-word",
                                }}
                                className="card-title-text"
                                title={item.title}
                              >
                                {item.title}
                              </span>

                              <div style={{ flexShrink: 0 }}>
                                <CloseOutlined
                                  style={{ cursor: "pointer" }}
                                  onClick={() => AddRemoveWidgets(`${item.number}`, 0)}
                                />
                              </div>
                            </div>
                          }
                          bordered={false}
                          style={{
                            backgroundColor: item.background,
                            textAlign: "left",
                            overflow: "hidden",
                            wordBreak: "break-word",
                            height: "100%", // ✅ Full block height (matches siblings)
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                          }}
                          bodyStyle={{
                            paddingTop: 0,
                            flexGrow: 1,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{
                              textAlign: "left",
                              overflow: "hidden",
                              flexGrow: 1,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              className="stats-card"
                              style={{
                                textAlign: "left",
                                overflow: "hidden",
                              }}
                            >
                              <h4
                                style={{
                                  margin: 0,
                                  textAlign: "left",
                                }}
                                title={item.value}
                              >
                                {item.value}
                              </h4>
                              <p
                                style={{
                                  margin: "4px 0",
                                  textAlign: "left",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                                title={item.subtitle}
                              >
                                {item.subtitle}
                              </p>
                            </div>

                            {isSwitchChecked && (
                              <div
                                className="status_card1"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "flex-start",
                                  gap: "6px",
                                  overflow: "hidden",
                                }}
                              >
                                {item.color && (
                                  <p
                                    className={
                                      item.color === "G"
                                        ? "text-success"
                                        : item.color === "R"
                                          ? "text-danger"
                                          : ""
                                    }
                                    style={{
                                      margin: 0,
                                      overflow: "hidden",
                                      whiteSpace: "nowrap",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    ({item.percent}%)
                                  </p>
                                )}
                              </div>
                            )}
                          </div>
                        </Card>

                      </Col>
                    ))}
                </Row>
              </Spin>
              </Card> */}
              </div>
            </div>
          </div>
          <div className="all-charts-scroll-container">
            {/* {[1].some((id) => selectedWidgets?.includes(id)) && ( */}
            <Card
              style={{ overflowX: "auto", marginTop: "16px" }}
              className="chart-card"
              title="Total Consignment & Delivered"
              bordered={false}
              id="Consignment Vs Delivered"
              extra={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "23px",
                  }}
                >
                  <LeftOutlined
                    onClick={handlePrev}
                    style={{
                      cursor: "pointer",
                    }}
                  />
                  <RightOutlined
                    onClick={handleNext}
                    style={{
                      cursor: "pointer",
                    }}
                  />
                  <div className="Iconbg">
                    <img
                      title="Export Icon"
                      src={ExportIcon}
                      alt="Export Icon"
                      style={{
                        cursor: exportAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!exportAllowed) return;
                        handleDownloadChart(
                          "Consignment Vs Delivered",
                          "Consignment Vs Delivered",
                        );
                      }}
                    />
                  </div>

                  <CloseOutlined
                    style={{ cursor: "pointer" }}
                    onClick={() => AddRemoveWidgets("1", 0)}
                  />
                </div>
              }
            >
              <div className="container_scrollable">
                <ConsigndeliveryChart data={paginatedData} />
              </div>
            </Card>
            {/* // )} */}
          </div>

          <div className="all-charts-scroll-container">
            {[8].some((id) => selectedWidgets?.includes(id)) && (
              <Card
                // style={{ overflowX: "auto" }}
                className="chart-card"
                title="Trips Per Vehicle"
                bordered={false}
                id="Trip Per Vehicle"
                extra={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end", // Aligns icons to the right
                      gap: "16px",
                      minWidth: "80px",
                    }}
                  >
                    <LeftOutlined
                      onClick={tripHandlePrev}
                      style={{
                        cursor: "pointer",
                      }}
                    />
                    <RightOutlined
                      onClick={tripHandleNext}
                      style={{
                        cursor: "pointer",
                      }}
                    />
                    <div
                      className="Iconbg"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: exportAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!exportAllowed) return;
                        handleDownloadChart(
                          "Trip Per Vehicle",
                          "Trip Per Vehicle",
                        );
                      }}
                    >
                      <img
                        title="Export Icon"
                        src={ExportIcon}
                        alt="Export Icon"
                        style={{ width: 20, height: 20 }}
                      />
                    </div>

                    <CloseOutlined
                      style={{
                        cursor: "pointer",
                        fontSize: "16px",
                      }}
                      onClick={() => AddRemoveWidgets("8", 0)}
                    />
                  </div>
                }
              >
                <TripPerVehicleChart data={tripPaginatedData} />
              </Card>
            )}
          </div>
          <Styledashboard>
            <div className="all-charts-scroll-container">
              {[3].some((id) => selectedWidgets?.includes(id)) && (
                <Card
                  className="chart-card"
                  title="Top 10 Clients"
                  bordered={false}
                  id="Clients"
                  extra={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end", // Align to the right
                        gap: "16px",
                        minWidth: "80px",
                      }}
                    >
                      <div
                        className="Iconbg"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: exportAllowed ? "pointer" : "not-allowed",
                        }}
                        onClick={() => {
                          if (!exportAllowed) return;
                          handleDownloadChart("Clients", "Clients");
                        }}
                      >
                        <img
                          title="Export Icon"
                          src={ExportIcon}
                          alt="Export Icon"
                          style={{ width: 20, height: 20 }}
                        />
                      </div>

                      <CloseOutlined
                        style={{
                          cursor: "pointer",
                          fontSize: "16px",
                        }}
                        onClick={() => AddRemoveWidgets("3", 0)}
                      />
                    </div>
                  }
                >
                  <div className="chart-wrapper">
                    <TopClientsChart
                      className="donut-chart"
                      total={total}
                      data={paginatedClients}
                    />
                  </div>
                </Card>
              )}
            </div>
          </Styledashboard>
          <div className="all-charts-scroll-container">
            {[9, 10, 11].some((id) => selectedWidgets?.includes(id)) && (
              <Card
                style={{ overflowX: "auto" }}
                className="chart-card"
                title="Vehicle Performance"
                bordered={false}
                id="Vehicle Performance"
                extra={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end", // right aligned
                      gap: "16px",
                      minWidth: "80px",
                    }}
                  >
                    {/* <LeftOutlined
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={handleVehiclePrev}
                    />
                    <RightOutlined
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={handleVehicleNext}
                    /> */}
                    <div
                      className="Iconbg"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: exportAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!exportAllowed) return;
                        handleDownloadChart(
                          "Vehicle Performance",
                          "Vehicle Performance",
                        );
                      }}
                    >
                      <img
                        title="Export Icon"
                        src={ExportIcon}
                        alt="Export Icon"
                        style={{ width: 20, height: 20 }}
                      />
                    </div>

                    <CloseOutlined
                      style={{
                        cursor: "pointer",
                        fontSize: "16px",
                      }}
                      onClick={() => AddRemoveWidgets("9,10,11", 0)}
                    />
                  </div>
                }
              >
                <VehiclePerformanceChart data={paginatedVehicleData} />
              </Card>
            )}
          </div>
          <div className="all-charts-scroll-container">
            {[20, 21].some((id) => selectedWidgets?.includes(id)) && (
              <Card
                style={{ overflowX: "auto" }}
                className="chart-card"
                title="Vehicle Mileage Performance"
                bordered={false}
                id="Vehicle Mileage Performance"
                extra={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end", // right aligned
                      gap: "16px",
                      minWidth: "80px",
                    }}
                  >
                    {/* <LeftOutlined
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={handleVehiclePrev}
                    />
                    <RightOutlined
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={handleVehicleNext}
                    /> */}
                    <div
                      className="Iconbg"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: exportAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!exportAllowed) return;
                        handleDownloadChart(
                          "Vehicle Mileage Performance",
                          "Vehicle Mileage Performance",
                        );
                      }}
                    >
                      <img
                        title="Export Icon"
                        src={ExportIcon}
                        alt="Export Icon"
                        style={{ width: 20, height: 20 }}
                      />
                    </div>

                    <CloseOutlined
                      style={{
                        cursor: "pointer",
                        fontSize: "16px",
                      }}
                      onClick={() => AddRemoveWidgets("9,10,11", 0)}
                    />
                  </div>
                }
              >
                <VehicleMileagePerformanceChart
                  data={vehicleMileagePerfomance}
                />
              </Card>
            )}
          </div>
          <div className="all-charts-scroll-container">
            {[20, 21].some((id) => selectedWidgets?.includes(id)) && (
              <Card
                style={{ overflowX: "auto" }}
                className="chart-card"
                title="Vehicle Fuel Performance"
                bordered={false}
                id="Vehicle Fuel Performance"
                extra={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end", // right aligned
                      gap: "16px",
                      minWidth: "80px",
                    }}
                  >
                    {/* <LeftOutlined
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={handleVehiclePrev}
                    />
                    <RightOutlined
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={handleVehicleNext}
                    /> */}
                    <div
                      className="Iconbg"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: exportAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!exportAllowed) return;
                        handleDownloadChart(
                          "Vehicle Fuel Performance",
                          "Vehicle Fuel Performance",
                        );
                      }}
                    >
                      <img
                        title="Export Icon"
                        src={ExportIcon}
                        alt="Export Icon"
                        style={{ width: 20, height: 20 }}
                      />
                    </div>

                    <CloseOutlined
                      style={{
                        cursor: "pointer",
                        fontSize: "16px",
                      }}
                      onClick={() => AddRemoveWidgets("9,10,11", 0)}
                    />
                  </div>
                }
              >
                <VehicleFuelPerformanceChart data={vehicleFuelPerfomance} />
              </Card>
            )}
          </div>
        </Styledashboard>
      </div>
      <Styledashboard>
        <UIModal
          header="Add Widgets"
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          footer={[
            <div
              key="footer"
              style={{
                marginRight:
                  window.innerWidth >= 320 && window.innerWidth <= 426
                    ? "-12px"
                    : null,

                display: "flex",
                flexDirection:
                  window.innerWidth >= 320 && window.innerWidth <= 426
                    ? ""
                    : "row",
                justifyContent: "flex-end",
                gap:
                  window.innerWidth >= 320 && window.innerWidth <= 426
                    ? "5px"
                    : "10px",
              }}
              className="addwidgets_container"
            >
              <Buttontransparent
                onClick={() => {
                  setIsModalOpen(false);
                  getUserWidget();
                }}
                style={{
                  marginLeft:
                    window.innerWidth >= 320 && window.innerWidth <= 426
                      ? "-10px"
                      : null,
                  fontSize: "12px",
                  width:
                    window.innerWidth >= 320 && window.innerWidth <= 426
                      ? "80px"
                      : "130px",
                }}
              >
                Cancel
              </Buttontransparent>
              <ButtonFilled
                className="addwidgets"
                style={{
                  fontSize: "12px",
                  width:
                    window.innerWidth >= 320 && window.innerWidth <= 426
                      ? "100px"
                      : "130px",
                }}
                loading={loading}
                onClick={() =>
                  AddRemoveWidgets(
                    selectedWidgets?.map((item) => item).join(","),
                    1,
                  )
                }
              >
                Add Widgets
              </ButtonFilled>
            </div>,
          ]}
          size="550px"
          closeButton={false}
        >
          <div>
            <Select
              mode="multiple"
              value={selectedWidgets}
              onChange={handleChange}
              placeholder="Select"
              style={{ width: "100%" }}
              maxTagCount="responsive"
              dropdownRender={(menu) => (
                <>
                  <div style={{ padding: "5px" }}>
                    <Checkbox
                      checked={selectedWidgets?.length === WidgetsAi.length}
                      onChange={(e) =>
                        handleChange(e.target.checked ? ["all"] : [])
                      }
                    >
                      Select All
                    </Checkbox>
                  </div>
                  <div style={{ padding: "5px" }}>
                    <Input
                      placeholder="Search"
                      onChange={(e) => setSearchText(e.target.value)}
                    />
                  </div>
                  {menu}
                </>
              )}
            >
              {filteredWidgets.map((role) => {
                return (
                  <Option key={role?.value} value={role?.value}>
                    <Checkbox checked={selectedWidgets?.includes(role?.value)}>
                      {role?.name}
                    </Checkbox>
                  </Option>
                );
              })}
            </Select>
          </div>
        </UIModal>
      </Styledashboard>
      <Modal
        open={isfilterModalOpen}
        onCancel={handleCancel}
        width={900}
        footer={
          <ButtonFilled
            onClick={() => {
               const clearedValues = { Duration: "CurrentMonth", Daterange: [dayjs().startOf("month"), dayjs().endOf("month")] }; // your default
                form.setFieldsValue({
                  vehicle: undefined,
                  consignor: undefined,
                  transporter: undefined,
                  fence: undefined,
                  tripType: undefined,
                  driver: undefined,
                  ShipmentType: undefined,
                  ...clearedValues,
                });
                setFormValues(clearedValues);
            }}
          >
            {" "}
            Clear All{" "}
          </ButtonFilled>
        }
      >
        <Row>
          <Col xl={24} xs={{ span: 24, order: 2 }}>
            <div className="container_for_kpi_filter">
              <h6 className="Filter_for_clickablerow">
                Filter ({filterCount})
              </h6>
              {/* <p className="Filter_for_Result">4 Result Found </p> */}
            </div>
          </Col>
        </Row>
        <Styledashboard>
          {" "}
          <Form
            form={form}
            layout="vertical"
            onValuesChange={(value, allvalues) => {
              getFilterCount();
              setFormValues({...formValues,...allvalues});
            }}
            initialValues={formValues}
          >
            <Row gutter={16}>
              <Col xs={24} sm={12} md={6}>
                <Form.Item label="Vehicle" name="vehicle">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={AIVehicleLists?.map((item) => ({
                      value: item?.FGUID,
                      label: item?.FVehicleName,
                    }))}
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={6}>
                <Form.Item label="Consignor" name="consignor">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={consignerList?.map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))}
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col xs={12} sm={12} md={6}>
                <Form.Item label="Transporter" name="transporter">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={transporterList?.map((item) => ({
                      label: item.Name,
                      value: item.ID,
                    }))}
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col xs={12} sm={12} md={6}>
                <Form.Item label="Consignee" name="fence">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={fenceList?.map((item) => ({
                      label: item.FName,
                      value: item.FGUID,
                    }))}
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>

              {/* <Col xs={24} sm={12} md={6}>
                <Form.Item label="Duration" name="Duration">
                  <Select>
                    {Duration.map((item) => (
                      <Option key={item.value} value={item.value}>
                        {item?.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={6}>
                <Form.Item
                  label="Date Range"
                  name="Daterange"
                  style={{ width: "100%" }}
                >
                  <RangePicker
                    className="range_picker"
                    defaultPickerValue={[dayjs(), dayjs()]}
                    value={null}
                    allowClear
                  />
                </Form.Item>
              </Col> */}
              <Col xs={24} sm={12} md={6}>
                <Form.Item label="Trip Type" name="tripType">
                  <Select className="w-100" showSearch allowClear>
                    <Option value={2}>Safari</Option>
                    <Option value={1}>Local</Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={6}>
                <Form.Item label="Driver" name="driver">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    // options={driverList?.map((item) => ({
                    //   label: item.FULLNM,
                    //   value: item.UID,
                    options={AIVehicleLists?.filter((item) => item?.FDriverName) // only keep if driver name exists
                      .map((item) => ({
                        // value: item?.FGUID,
                        // label: item?.FDriverName,
                        value: item?.FDriverName,
                        label: item?.FDriverName,
                      }))}
                    // }))}
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={6}>
                <Form.Item label="Shipment Type" name="ShipmentType">
                  <Select
                    className="w-100"
                    showSearch
                    optionFilterProp="children"
                    options={shipmentType?.map((item) => ({
                      label: item.name,
                      value: item.value,
                    }))}
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                    allowClear
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Styledashboard>
      </Modal>
    </>
  );
};

export default Dashboard;
